<script setup lang="ts">
  defineOptions({
    name: 'CPPortalSidebarIcon',
  })

  import type { Component, PropType } from 'vue'

  import { computed } from 'vue'

  import SidebarIcon from '@common/assets-layer/components/SidebarIcon.vue'

  const props = defineProps({
    channel: {
      type: Object as PropType<{
        iconName?: string
        fallbackIcon?: Component
      }>,
      default: undefined,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    class: {
      type: String,
      required: false,
      default: undefined,
    },
  })

  const iconName = computed(() => props.channel?.iconName)

  const useFallback = computed(() => !iconName.value && props.channel?.fallbackIcon)
</script>

<template>
  <component :is="channel?.fallbackIcon" v-if="useFallback" :class="['h-5 w-5 flex-shrink-0', props.class]" />
  <SidebarIcon v-else-if="iconName" :icon-name="iconName" :is-active="isActive" :class="props.class" />
</template>
